/**
 * Servisler arası paylaşılan küçük HTTP yardımcıları.
 *
 * kod inceleme: `listeCevabi`/`temizParametreler`, `sorguOneriService.ts` (Faz 2)
 * ve `senkronPlanService.ts` (Faz 3) içinde birebir kopya olarak duruyordu;
 * tek modüle taşındı ki biri güncellenince diğeri sessizce geride kalmasın.
 */

/**
 * Uçlar çıplak dizi döndürüyor (`response()->json($liste)`), ama bu projede
 * bazı uçlar `{data: [...]}` sarmalıyor. İki şekli de kabul edip her hâlükârda
 * dizi döndürürüz — çağıran taraf `.length` üzerinden çalışabilsin.
 */
export function listeCevabi<T>(cevap: any): T[] {
    if (Array.isArray(cevap)) return cevap as T[];
    if (cevap && Array.isArray(cevap.data)) return cevap.data as T[];
    return [];
}

/** Tanımsız/boş alanları query string'e sokmamak için süzer. */
export function temizParametreler(parametreler: Record<string, any>): Record<string, any> {
    const sonuc: Record<string, any> = {};
    Object.keys(parametreler).forEach((anahtar) => {
        const deger = parametreler[anahtar];
        if (deger !== undefined && deger !== null && deger !== "") {
            sonuc[anahtar] = deger;
        }
    });
    return sonuc;
}
